"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
exports.createExpressionSorter = function (config) { return function (map) {
    var sortedExpressionList = [];
    var untouchedExpressionList = Object.keys(map).sort();
    var visit = function (path, ancesterKeys) {
        if (ancesterKeys === void 0) { ancesterKeys = []; }
        if (sortedExpressionList.includes(path))
            return true;
        if (ancesterKeys.includes(path)) {
            utils_1.throwError(new Error("Cirucular Expression Found: \n\t - \"" + ancesterKeys.slice().join('"\n\t - "') + "\""), config.errorOnCircularDep);
            return false;
        }
        var dependencies = map[path];
        if (dependencies && dependencies.length >= 0) {
            for (var _i = 0, dependencies_1 = dependencies; _i < dependencies_1.length; _i++) {
                var dependency = dependencies_1[_i];
                if (dependency && !visit(dependency, ancesterKeys.concat([path]))) {
                    var index = untouchedExpressionList.indexOf(path);
                    if (index >= 0) {
                        untouchedExpressionList.splice(index, 1);
                    }
                    return false;
                }
            }
            sortedExpressionList.push(path);
        }
        return true;
    };
    while (untouchedExpressionList.length > 0) {
        var path = untouchedExpressionList.shift();
        visit(path);
    }
    return sortedExpressionList;
}; };
//# sourceMappingURL=sort.js.map